import { useState, useMemo } from 'react';
import type { WorkspaceModule } from '@/lib/api/endpoints/workspaces';

interface ModuleFlyoutProps {
  title: string;
  isOpen: boolean;
  sidebarExpanded: boolean;
  modules: WorkspaceModule[];
  activeModuleId?: string;
  onSelect: (module: WorkspaceModule) => void;
  onClose: () => void;
}

export function ModuleFlyout({
  title,
  isOpen,
  sidebarExpanded,
  modules,
  activeModuleId,
  onSelect,
  onClose,
}: ModuleFlyoutProps) {
  const [searchQuery, setSearchQuery] = useState('');

  const displayed = useMemo(() => {
    if (!searchQuery) return modules;
    const q = searchQuery.toLowerCase();
    return modules.filter((m) => (m.label || '').toLowerCase().includes(q));
  }, [modules, searchQuery]);

  const leftOffset = sidebarExpanded ? 220 : 48;

  return (
    <>
      {isOpen && <div className="flyout-backdrop" onClick={onClose} />}
      <div
        className={`notebooks-flyout${isOpen ? ' open' : ''}`}
        style={{ left: `${leftOffset}px` }}
      >
        <div className="flyout-header">
          <span className="flyout-title">{title}</span>
        </div>

        {modules.length > 3 && (
          <input
            className="flyout-search"
            type="text"
            placeholder={`Search ${title.toLowerCase()}…`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        )}

        <div className="flyout-list xv-scroll">
          {displayed.length > 0 ? (
            displayed.map((mod) => (
              <button
                key={mod.id}
                className={`flyout-item${mod.id === activeModuleId ? ' active' : ''}`}
                onClick={() => onSelect(mod)}
              >
                <span className="flyout-item-dot pinned" />
                <span className="flyout-item-name">{mod.label || 'Untitled'}</span>
              </button>
            ))
          ) : (
            <div style={{ padding: '12px 14px', fontSize: 12, color: 'var(--rail-muted)' }}>
              {searchQuery ? 'No results' : `No ${title.toLowerCase()} yet`}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
